import { createSlice } from "@reduxjs/toolkit";
import { State } from "store/state";
import { cloneDeep } from "lodash";
import {
  BillingDetails,
  CartProgress,
  CartTotalAmount,
  PaymentProgress,
} from "./helper";

const initialBillingDetails: BillingDetails = {
  tradingName: "",
  name: "",
  vat: "",
  address: "",
  postCode: "",
  contact: "",
  contactPhoneNumber: 0,
  contactEmail: "",
  status: "received",
};

export type BillingDetailsKey = keyof typeof initialBillingDetails;
export type BankTransferBillingDetails = Pick<
  BillingDetails,
  | "postCode"
  | "vat"
  | "address"
  | "contact"
  | "contactEmail"
  | "contactPhoneNumber"
>;
const initialState = {
  checkoutProgress: CartProgress.CART,
  detailsProgress: PaymentProgress.DETAILS,
  billingDetails: initialBillingDetails,
  totalAmount: {
    withApproval: null,
    withoutApproval: 0,
  } as CartTotalAmount,
};

export const selectCartStepperStatus = (state: State) =>
  state.exhibitorCartStatus;

export const selectBillingDetails = (state: State) =>
  state.exhibitorCartStatus.billingDetails;

export const selectTotalAmount = (state: State) =>
  state.exhibitorCartStatus.totalAmount;

const cartStepperSlice = createSlice({
  name: "cartStepperStatus",
  initialState,
  reducers: {
    resetCartStepper: () => cloneDeep(initialState),
    goToPayment: (state) => ({
      ...state,
      checkoutProgress: CartProgress.PAYMENT,
      detailsProgress: PaymentProgress.DETAILS,
    }),
    goToCardDetails: (state) => ({
      ...state,
      detailsProgress: PaymentProgress.CARD_DETAILS,
    }),
    goToCart: (state) => ({ ...state, checkoutProgress: CartProgress.CART }),
    updateTotalAmount: (state, { payload }: { payload: CartTotalAmount }) => ({
      ...state,
      totalAmount: payload,
    }),
    updateBillingDetails: (
      state,
      { payload }: { payload: Partial<BillingDetails> }
    ) => ({
      ...state,
      billingDetails: { ...state.billingDetails, ...payload },
    }),
    resetBillingDetails: (state) => ({
      ...state,
      billingDetails: initialBillingDetails,
    }),
  },
});

export const {
  resetCartStepper,
  goToPayment,
  goToCardDetails,
  goToCart,
  updateBillingDetails,
  updateTotalAmount,
} = cartStepperSlice.actions;
export default cartStepperSlice.reducer;
